import { fromJS, List } from 'immutable';
import { parametric, dispatch, pathSubscription, subscription } from 'nike-re-framejs';

import { CHAT_TICKETS_PICK_LIMIT } from '@/forum/chat/constants';
import forumClient from '@/_http/axiosForumClient';
import { validateAnalysis } from '@/forum/chat/handlersAndSubs';
import { openErrorMessageModal } from '@/betbook/handlers';

export const addTopicReply = (topic, message) => db =>
    db.setIn(['forum', topic, 'reply'], message ? fromJS(message) : null);

export const forumTopicReset = topic => db => db.removeIn(['forum', topic]);
export const setTopicAnalyses = (topic, analyses) => db => db.setIn(['forum', topic, 'analyses'], fromJS(analyses));
export const setTopicTickets = (topic, tickets) => db => db.setIn(['forum', topic, 'tickets'], fromJS(tickets));

export const getTopicTickets = topic => pathSubscription(['forum', topic, 'tickets'], List());
export const getTopicAnalyses = topic => pathSubscription(['forum', topic, 'analyses'], List());

export const isTopicMaxedOut = parametric(topic =>
    subscription(tickets => tickets.size >= CHAT_TICKETS_PICK_LIMIT, getTopicTickets(topic))
);
export const getTopicReply = topic => pathSubscription(['forum', topic, 'reply']);

export const addTicketToTopic = (topic, ticket) => db =>
    db.updateIn(['forum', topic, 'tickets'], (tickets = List()) => {
        const t = fromJS(ticket);
        return tickets.size >= CHAT_TICKETS_PICK_LIMIT || tickets.includes(t) ? tickets : tickets.push(t);
    });

export const addAnalyseToTopic = (topic, analysis) => db =>
    db.updateIn(['forum', topic, 'analyses'], (analyses = List()) => {
        const t = analysis;
        return analyses.size >= CHAT_TICKETS_PICK_LIMIT || analyses.map(p => p.id).includes(t.id)
            ? analyses
            : analyses.push(t);
    });

export const removeTicketFromTopic = (topic, ticket) => db =>
    db.updateIn(['forum', topic, 'tickets'], (tickets = List()) => tickets.filter(t => t.get('hash') !== ticket.hash));

export const removeAnalyseFromTopic = (topic, analysis) => db =>
    db.updateIn(['forum', topic, 'analyses'], (analyses = List()) => analyses.filter(t => t.id !== analysis.id));

export const fetchAnalysePostAndSetToReframe = (topic, postId) => db => {
    forumClient
        .get(`/v5/betbook/analyses/${postId}`)
        .then(postDetail => dispatch(validateAnalysis(topic, postId, postDetail)))
        .catch(e => {
            openErrorMessageModal(e.response);
        });
    return db;
};
